import type { Attachment } from 'types/api/attachment';

export const compensationStatus = ['pending', 'received'] as const;
export type CompensationStatus = (typeof compensationStatus)[number];

// Single source of truth for the "compensated by" vocabulary. This is a Compensation
// concept (reused by trade requirements today, EPR / RFA tomorrow). Mirrors the
// backend Compensations::CompensatedBy module.
export const compensatedBy = ['lab', 'group', 'sales_rep', 'faks', 'opeaz', 'other'] as const;
export type CompensatedBy = (typeof compensatedBy)[number];

// Single source of truth for the "compensation method" vocabulary (the "Moyen" — how a
// compensation is paid). Mirrors the backend Compensations::CompensationMethod module.
export const compensationMethod = [
  'credit_note',
  'bank_transfer',
  'gift_voucher',
  'faks_transfer',
  'free_units',
  'sogec',
  'discount',
  'market',
  'other',
] as const;
export type CompensationMethod = (typeof compensationMethod)[number];

export const compensationTargetType = [
  'ExpiredProductsRequest',
  'Trades::Instance',
  'Invoice',
] as const;
export type CompensationTargetType = (typeof compensationTargetType)[number];

export const trackingType = ['automatic', 'manual'] as const;
export type TrackingType = (typeof trackingType)[number];

export type Compensation = {
  id: number;
  compensated_amount_in_euro_cents: number | null;
  expected_compensated_amount_in_euro_cents: number | null;
  expected_paid_at: string | null;
  status: CompensationStatus;
  target_type: CompensationTargetType | null;
  payment_proof: Attachment[] | null;
  paid_at: string | null;
  comment: string | null;
  compensation_method: CompensationMethod | null;
  compensated_by: CompensatedBy | null;
  expected_compensation_method: CompensationMethod | null;
  expected_compensated_by: CompensatedBy | null;
  tracking_type: TrackingType | null;
};
